import { render } from "./product4.vue?vue&type=template&id=d10151be&scoped=true"
import script from "./product4.vue?vue&type=script&lang=js"
export * from "./product4.vue?vue&type=script&lang=js"

import "./product4.vue?vue&type=style&index=0&id=d10151be&lang=less&scoped=true"

import exportComponent from "E:\\develop\\company\\gw\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d10151be"]])

export default __exports__